import { message, Upload } from "antd";
import { URL_CONCESIONARIOS } from "../../../constants/url";
import { postFile } from "../../../utils/fetch";
import { CloudUploadOutlined } from "@ant-design/icons";

const { Dragger } = Upload;

export const FormaCarga = () => {
  const uploadFile = async (file) => {
    const url = `${URL_CONCESIONARIOS}/LeerXLS`;
    const formData = new FormData();
    formData.append("file", file);

    var upploadResult = await postFile(url, formData);
    if (upploadResult.code === 0) message.success(upploadResult.data, 5);
    else message.error(upploadResult.error, 5);
  };

  const props = {
    name: "file",
    multiple: false,
    action: uploadFile,
    onDrop(e) {
    //  console.log("Dropped files", e.dataTransfer.files);
      return;
    },
  };

  return (
    <Dragger {...props} showUploadList={false}>
      <p className="ant-upload-drag-icon">
        <CloudUploadOutlined />
      </p>
      <p className="ant-upload-text">Click o arrastra algun archivo</p>
      <p className="ant-upload-hint">
        Solamente soporta un solo archivo y de formato Excel
      </p>
    </Dragger>
  );
};
